<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">

    <div class="title-wrapper mb-4">
      <div>
        <h1 class="title-default">{{ titulo }}</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="cancelar()" aria-label="Voltar para a listagem">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Preencha os dados do registro
        </p>
      </div>
    </div>

    @if (isLoading) {
    <app-loading-box height="200"></app-loading-box>
    } @else {
    <form [formGroup]="model">
      <div class="section-container">
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">account_balance</mat-icon>
          <span>Dados do Tipo Tributário</span>
        </div>

        <div class="row g-3">
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>Código</mat-label>
              <input matInput formControlName="codigo" maxlength="10" placeholder="Ex.: 00" class="campo-codigo" />
              @if (model.get('codigo')?.touched && model.get('codigo')?.hasError('required')) {
              <mat-error>Informe o Código.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-12 col-md-9">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>Descrição</mat-label>
              <input matInput formControlName="descricao" maxlength="120"
                placeholder="Ex.: Tributada integralmente" />
              @if (model.get('descricao')?.touched && model.get('descricao')?.hasError('required')) {
              <mat-error>Informe a Descrição.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-12">
            <div class="toggle-content">
              <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivo">{{ statusLabel }}</mat-slide-toggle>
            </div>
          </div>
        </div>
      </div>
    </form>
    }

  </div>
</div>

<app-footer-action salvarLabel="Salvar" [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading"
  (cancelar)="cancelar()" (salvar)="salvar()">
</app-footer-action>
